import angular from "angular";
import STATE_LIST from "../../consts/stateList";
import CommonValidator from "./common";

// Define Error Prefix
const CREDIT_PREFIX = 3000;

// Define Error Codes
const MISSING_NAME = CREDIT_PREFIX + 1;
const MISSING_ADDRESS = CREDIT_PREFIX + 2;
const MISSING_CITY = CREDIT_PREFIX + 3;
const MISSING_STATE = CREDIT_PREFIX + 4;
const INVALID_STATE = CREDIT_PREFIX + 5;
const MISSING_ZIP_CODE = CREDIT_PREFIX + 6;
const INVALID_ZIP_CODE = CREDIT_PREFIX + 7;
const MISSING_CARD_NUMBER = CREDIT_PREFIX + 8;
const INVALID_CARD_NUMBER = CREDIT_PREFIX + 9;
const MISSING_CVC = CREDIT_PREFIX + 10;
const INVALID_CVC = CREDIT_PREFIX + 11;
const MISSING_MONTH = CREDIT_PREFIX + 12;
const INVALID_MONTH = CREDIT_PREFIX + 13;
const MISSING_YEAR = CREDIT_PREFIX + 14;
const INVALID_YEAR = CREDIT_PREFIX + 15;
const INVALID_EXPIRATION_DATE = CREDIT_PREFIX + 16;

// Public Error Codes
export const CREDIT_CARD_ERRORS = {
  MISSING_NAME,
  MISSING_ADDRESS,
  MISSING_CITY,
  MISSING_STATE,
  INVALID_STATE,
  MISSING_ZIP_CODE,
  INVALID_ZIP_CODE,
  MISSING_CARD_NUMBER,
  INVALID_CARD_NUMBER,
  MISSING_CVC,
  INVALID_CVC,
  MISSING_MONTH,
  INVALID_MONTH,
  MISSING_YEAR,
  INVALID_YEAR,
  INVALID_EXPIRATION_DATE,
};

// Corresponding Error Messages
export const CREDIT_CARD_MESSAGES = {
  [INVALID_EXPIRATION_DATE]: "Expiration date has passed.",
};

export default class CreditCardValidator {
  static validateState(state) {
    let errors = [];

    if (CommonValidator.doesNotExist(state)) errors.push(MISSING_STATE);

    if (STATE_LIST.indexOf(state) === -1) errors.push(INVALID_STATE);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static validateZipCode(zipCode) {
    let errors = [];

    if (CommonValidator.doesNotExist(zipCode)) errors.push(MISSING_ZIP_CODE);

    if (!ZIP_CODE_REGEX.test(zipCode)) errors.push(INVALID_ZIP_CODE);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static validateCardNumber(cardNumber) {
    cardNumber = cardNumber ? cardNumber.replace(/[ -]/g, "") : cardNumber;

    let errors = [];

    if (CommonValidator.doesNotExist(cardNumber)) errors.push(MISSING_CARD_NUMBER);

    if (!CARD_NUMBER_REGEX.test(cardNumber)) errors.push(INVALID_CARD_NUMBER);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static validateExpMonth(month) {
    let errors = [];

    month = month ? parseFloat(month) : month;

    if (CommonValidator.doesNotExist(month)) errors.push(MISSING_MONTH);

    if (month > 12 || month % 1 !== 0) errors.push(INVALID_MONTH);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static validateExpYear(year) {
    let errors = [];

    year = year ? parseFloat(year) : year;
    const thisYear = new Date().getFullYear();

    if (CommonValidator.doesNotExist(year)) errors.push(MISSING_YEAR);

    if (year < thisYear || year % 1 !== 0) errors.push(INVALID_YEAR);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static validateExpDate(month, year) {
    let errors = [];

    month = month ? parseFloat(month) : 0;
    year = year ? parseFloat(year) : 0;
    const totalMonths = month + year * 12;

    const thisYear = new Date().getFullYear();
    const thisMonth = new Date().getMonth() + 1;

    const thisTotalMonths = thisMonth + thisYear * 12;

    const monthValidation = this.validateExpMonth(month);
    const yearValidation = this.validateExpYear(year);

    if (!monthValidation.isValid) errors.push(...monthValidation.errors);

    if (!yearValidation.isValid) errors.push(...yearValidation.errors);

    if (totalMonths < thisTotalMonths || !yearValidation.isValid || !monthValidation.isValid) errors.push(INVALID_EXPIRATION_DATE);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static validateCVC(cvc) {
    let errors = [];

    if (CommonValidator.doesNotExist(cvc)) errors.push(MISSING_CVC);

    if (!CVC_REGEX.test(cvc)) errors.push(INVALID_CVC);

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static constructErrorMessage(errors) {
    const message = [];

    errors.forEach((error) => {
      message.push(CREDIT_CARD_MESSAGES[error]);
    });

    return message.join(" ");
  }
}

const ZIP_CODE_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;
// Visa | Mastercard | Discover | AMEX | Diners | JCB
const CARD_NUMBER_REGEX =
  /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])?[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
const CVC_REGEX = /^[0-9]{3,4}$/;



// WEBPACK FOOTER //
// ./client/app/services/validation/creditCard.js